import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { childrenLogisticsNetworkPageBreadcrumbs } from '@/pages/Business/config';
import { NavigateFunction } from 'react-router-dom';

export const childrenUsersPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenLogisticsNetworkPageBreadcrumbs(navigate),
  { label: 'Usuarios', onClick: () => navigate('/business/users') },
];

